declare namespace $ {

	export class $mol_icon_image_multiple extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=multiple.view.tree.d.ts.map